module.exports = (__webpack_require__(11))(2667);